import moment from "moment-timezone";

import { fetchAuthSessionWithLock } from "@src/appV2/Auth/cognito/cognitoSessionLock";

import { logout } from "./../session";

/**
 * Logs the user out when their Cognito session has exceeded `validTillInHours`
 * since the auth_time claim. Used by the legacy admin 24-hour-session feature
 * (see `useLogoutIn24Hours`).
 */
export const keepUserSessionAlive = async (dispatch, validTillInHours = 720) => {
  let authTime: string | undefined;

  try {
    const session = await fetchAuthSessionWithLock();
    const authTimeSec = session.tokens?.idToken?.payload?.auth_time;
    if (typeof authTimeSec === "number") {
      authTime = new Date(authTimeSec * 1000).toISOString();
    }
  } catch {
    // No valid Cognito session — let the caller decide what to do.
    return;
  }

  if (authTime && moment().diff(moment(authTime), "hours") >= validTillInHours) {
    dispatch(logout());
  }
};
